<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: value =>
      ['draft', 'active', 'shared', 'fulfilled', 'archived'].includes(value),
  },
});

const { t } = useI18n();

const label = computed(() => {
  const labels = {
    draft: t('PURCHASE_PROJECTS.STATUSES.DRAFT'),
    active: t('PURCHASE_PROJECTS.STATUSES.ACTIVE'),
    shared: t('PURCHASE_PROJECTS.STATUSES.SHARED'),
    fulfilled: t('PURCHASE_PROJECTS.STATUSES.FULFILLED'),
    archived: t('PURCHASE_PROJECTS.STATUSES.ARCHIVED'),
  };
  return labels[props.status] ?? labels.draft;
});
</script>

<template>
  <span
    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
    :class="{
      'bg-n-slate-3 text-n-slate-11': status === 'draft',
      'bg-n-blue-3 text-n-blue-11': status === 'active',
      'bg-n-amber-3 text-n-amber-11': status === 'shared',
      'bg-n-teal-3 text-n-teal-11': status === 'fulfilled',
      'bg-n-ruby-3 text-n-ruby-11': status === 'archived',
    }"
  >
    {{ label }}
  </span>
</template>
